import { Label } from "@/components/ui/label";

export const Field = ({ label, error, hint, children, name, className }) => (
  <div className={`space-y-2 ${className || ""}`}>
    <Label htmlFor={name} className="text-[13px] font-semibold">{label}</Label>
    {children}
    {error ? (
      <p className="text-xs font-medium text-destructive" data-testid={`error-${name}`}>{error}</p>
    ) : hint ? (
      <p className="text-xs text-muted-foreground">{hint}</p>
    ) : null}
  </div>
);
